export default __webpack_public_path__ + "static/media/Times New Roman Bold Italic.5fecf056.ttf";